/* MUI Imports */
import AutoPay from "../components/payments/AutoPay";

const Payments = () => {
    return <AutoPay />;
};

export default Payments;
